"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnotherTranslationList = void 0;
const react_1 = __importDefault(require("react"));
const api_1 = require("./api");
const AnotherTranslation_1 = require("./AnotherTranslation");
const react_bootstrap_1 = require("react-bootstrap");
const AnotherTranslationList = ({ text, langId, context, prompt, description, projectId, onApply }) => {
    const [translationList, setTranslationList] = react_1.default.useState([]);
    const [currentIndex, setCurrentIndex] = react_1.default.useState(0);
    const onChangeTranslation = (translation, index) => {
        setTranslationList((prev) => {
            const next = [...prev];
            next[index] = translation;
            return next;
        });
        if (index < 4) {
            setCurrentIndex(index + 1);
        }
    };
    return (react_1.default.createElement(react_bootstrap_1.Stack, null, [...Array.from({ length: 5 })].map((_, index) => index <= currentIndex && (react_1.default.createElement(AnotherTranslation_1.AnotherTranslation, { text: text, langId: langId, context: context, prompt: prompt, additionalPrompt: translationList.length > 0 && index !== 0
            ? {
                user: (0, api_1.additionalAnotherTranslationUserPrompt)(translationList.slice(0, index)),
            }
            : undefined, description: description, projectId: projectId, onChangeTranslation: (translation) => onChangeTranslation(translation, index), onApply: onApply, key: index })))));
};
exports.AnotherTranslationList = AnotherTranslationList;
